import React from 'react';
import { Quote, TrendingUp } from 'lucide-react';

const OnboardingTestimonials = () => {
  return (
    <section className="py-20 px-6 bg-gray-900">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Testimonial */}
          <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-8 border border-gray-700 relative shadow-[0_0_30px_rgba(59,130,246,0.1)]">
            <Quote className="w-12 h-12 text-blue-400/20 absolute top-6 right-6" />
            <div className="relative z-10">
              <p className="text-xl text-gray-200 mb-6 italic leading-relaxed">
                "The onboarding was unlike anything we've experienced. They didn't just show us the platform — they built our entire training system with us. Our team was up and running in two weeks, and we saw measurable improvements within 30 days."
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-blue-900/50 border border-blue-700 rounded-full flex items-center justify-center">
                  <span className="text-lg font-bold text-blue-400">M</span>
                </div>
                <div>
                  <p className="font-semibold text-white">Michael Rodriguez</p>
                  <p className="text-sm text-gray-400">VP of Sales Operations, TechFlow</p>
                </div>
              </div>
            </div>
          </div>

          {/* Metric Callout */}
          <div className="bg-gradient-to-br from-blue-900/20 to-indigo-900/20 rounded-2xl p-8 border border-blue-700 flex flex-col justify-center">
            <TrendingUp className="w-12 h-12 text-blue-400 mb-6" />
            <div className="space-y-6">
              <div>
                <div className="text-5xl font-bold text-blue-400 mb-2">40%</div>
                <p className="text-gray-300">Reduction in new hire ramp time</p>
              </div>
              <div>
                <div className="text-5xl font-bold text-blue-400 mb-2">3 weeks</div>
                <p className="text-gray-300">Average time to full deployment</p>
              </div>
              <div>
                <div className="text-5xl font-bold text-blue-400 mb-2">98%</div>
                <p className="text-gray-300">Customer satisfaction with onboarding</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnboardingTestimonials;